import React from 'react';
import Star from "./Star";

// Types ----

type StarRatingProps = {
  max: number
  score: number
}

// Component ----

function StarRating({max, score}: StarRatingProps) {

  const stars = Array(max).fill('star');

  return (
    <ul className="flex">
      {stars.map((_star, index) => (
        <li key={index}>
          <Star filled={score >= (index + 1)} />
        </li>
      ))}
    </ul>
  );
}

// Export ----

export default StarRating;